import './Overlay.scss';

const Overlay = () => {
  return <div className="overlay"></div>;
};

export default Overlay;
